(function () {
  function initBuilder(root) {
    var dataEl = root.querySelector('[data-builder-products]');
    if (!dataEl) return;
    var PRODUCTS = JSON.parse(dataEl.textContent);
    var tiers = JSON.parse(root.getAttribute('data-tiers'));
    var cartAddUrl = root.getAttribute('data-cart-add-url');
    var cartUrl = root.getAttribute('data-cart-url');
    var removeLabel = (window.SH_I18N && window.SH_I18N.bundle_builder_remove_label) || 'Verwijder';

    function fmt(n) {
      return '€ ' + n.toLocaleString('nl-NL', { minimumFractionDigits: (n % 1 !== 0) ? 2 : 0, maximumFractionDigits: 2 });
    }

    var selected = {};

    ['toestel', 'accessoire'].forEach(function (cat) {
      var grid = root.querySelector('.sh-bp-grid[data-cat="' + cat + '"]');
      if (!grid) return;
      PRODUCTS.filter(function (p) { return p.cat === cat; }).forEach(function (p) {
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'sh-bproduct';
        card.setAttribute('data-id', p.id);
        card.innerHTML =
          '<span class="sh-bp-media">' + (p.img ? '<img src="' + p.img + '" alt="' + p.name + '" loading="lazy">' : '') + '<span class="sh-bp-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span></span>' +
          '<span class="sh-bp-name">' + p.name + '</span>' +
          (p.note ? '<span class="sh-bp-note">' + p.note + '</span>' : '') +
          '<span class="sh-bp-price">' + fmt(p.price) + '</span>';
        card.addEventListener('click', function () {
          if (selected[p.id]) { delete selected[p.id]; } else { selected[p.id] = p; }
          card.classList.toggle('sh-sel', !!selected[p.id]);
          render();
        });
        grid.appendChild(card);
      });
    });

    var bsEmpty = root.querySelector('[data-bs-empty]');
    var bsList = root.querySelector('[data-bs-list]');
    var bsSub = root.querySelector('[data-bs-sub]');
    var bsSave = root.querySelector('[data-bs-save]');
    var bsSaveRow = root.querySelector('[data-bs-save-row]');
    var bsTotal = root.querySelector('[data-bs-total]');
    var bsAdd = root.querySelector('[data-bs-add]');
    var bsTiers = root.querySelector('[data-bs-tiers]');

    function currentTier(count) {
      for (var i = 0; i < tiers.length; i++) {
        if (count >= tiers[i].min) return tiers[i];
      }
      return { min: 0, pct: 0 };
    }

    function render() {
      var items = Object.keys(selected).map(function (k) { return selected[k]; });
      var count = items.length;

      bsEmpty.style.display = count ? 'none' : 'block';
      bsList.innerHTML = items.map(function (p) {
        return '<li><span class="sh-bl-name">' + p.name + '</span><span class="sh-bl-price">' + fmt(p.price) + '</span>' +
          '<button type="button" class="sh-bl-remove" data-id="' + p.id + '" aria-label="' + removeLabel + '">&times;</button></li>';
      }).join('');
      bsList.querySelectorAll('.sh-bl-remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-id');
          delete selected[id];
          var card = root.querySelector('.sh-bproduct[data-id="' + id + '"]');
          if (card) card.classList.remove('sh-sel');
          render();
        });
      });

      var subtotal = items.reduce(function (s, p) { return s + p.price; }, 0);
      var tier = currentTier(count);
      var pct = tier.pct;
      var save = subtotal * pct / 100;
      var total = subtotal - save;

      bsTiers.querySelectorAll('.sh-bt').forEach(function (el) {
        el.classList.toggle('sh-active', parseInt(el.getAttribute('data-tier'), 10) === tier.min);
      });

      bsSub.textContent = fmt(subtotal);
      bsSaveRow.style.display = pct ? 'flex' : 'none';
      bsSave.textContent = '− ' + fmt(save);
      bsTotal.textContent = fmt(total);
      bsAdd.disabled = count === 0;
      bsAdd.textContent = count ? (bsAdd.getAttribute('data-label') + ' · ' + fmt(total)) : bsAdd.getAttribute('data-label');

      bsAdd.onclick = function () {
        if (!count) return;
        bsAdd.disabled = true;
        var originalLabel = bsAdd.textContent;
        bsAdd.textContent = '...';
        fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items.map(function (p) { return { id: p.id, quantity: 1 }; }) })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart add failed');
            if (window.SHCart) {
              window.SHCart.refresh().then(window.SHCart.open);
              bsAdd.disabled = false;
              bsAdd.textContent = originalLabel;
            } else {
              window.location.href = cartUrl;
            }
          })
          .catch(function () {
            bsAdd.disabled = false;
            bsAdd.textContent = originalLabel;
          });
      };
    }

    render();
  }

  document.querySelectorAll('[data-sh-bundle-builder]').forEach(initBuilder);
})();
